import React, {memo, useState, ReactNode, useCallback, useEffect} from "react"
import {Column} from "../../Column"
import {ControlModel, ControlTypeModel} from "../../../types/control"
import {useDebounce} from "../../../hooks/debounce"
import {useRPC} from "../../../hooks/rpc"
import {RgbColor} from "../../ColorPicker/types"
import {RGBColorPickerComponent} from "./components"

type Props = {
    control: ControlModel
    controlType: ControlTypeModel
    children?: ReactNode
}

export const RGBPicker = memo(function RGBPicker(props: Props) {
    const {control, children, controlType} = props
    const [color, setColor] = useState(
        {r: control.parameters["r"], g: control.parameters["g"], b: control.parameters["b"]} || {r: 255, g: 0, b: 70}
    )
    const [value, setValue] = useState<number>(control.current_value)
    const [rpc] = useRPC()

    const handleChange = useDebounce((color: RgbColor) => {
        setColor(color)
        rpc.updateRGBControlValue(control.id, value, color)
    }, 600)

    const onChange = useCallback(
        (value: number) => {
            setColor(color)
            setValue(value)
            rpc.updateRGBControlValue(control.id, value, color)
        },
        [rpc, color, control.id]
    )

    useEffect(() => {
        setColor({
            r: control.parameters["r"],
            g: control.parameters["g"],
            b: control.parameters["b"]
        })
    }, [control])

    return (
        <Column min={6} max={12}>
            <RGBColorPickerComponent
                color={color}
                name={control.name}
                value={control.current_value}
                onChange={onChange}
                onChangeColor={handleChange}
                activeImage={controlType.image_set.active}
                passiveImage={controlType.image_set.passive}
            >
                {children}
            </RGBColorPickerComponent>
        </Column>
    )
})
